var render = function render(){var _vm=this,_c=_vm._self._c;return _c('progress',{staticClass:"progress-bar vue",class:{ 'progress-bar--error': _vm.error },style:({'--progress-bar-height': _vm.height }),attrs:{"max":"100"},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }